// extracted by mini-css-extract-plugin
export default {"box":"index_box_aFbVt","logo":"index_logo_4uMAX","nav":"index_nav_TV8Rh"};